import { render, staticRenderFns } from "./MenuWine.vue?vue&type=template&id=740a899f&scoped=true&"
import script from "./MenuWine.vue?vue&type=script&lang=js&"
export * from "./MenuWine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740a899f",
  null
  
)

export default component.exports